import Alpine from 'alpinejs';
import '../css/app.css';

window.Alpine = Alpine;

// Vendor
import './vendor/prism.js';
import './vendor/aos.js';

// Components
import './components/fanuc-product-renaming';
import './components/wistia-player-controller';
import './components/wistia-cover-loader';
import './components/video-progress-tracker';
import './components/code-snippet-copy';

Alpine.start();
